export const imageProductViewerProps = () => ({
  images: {
    type: Array,
    required: true
  },
  productName: {
    type: String,
    required: false,
    default: ""
  },
  pictoPrincipal: {
    type: Object,
    required: false,
    default: null
  }
})

export const useImageProductViewer = (props, context) => {
  const showModal = ref(false)
  const principalImage = ref(props.images[0])
  const handleClick = (image) => {
    if (image.type === 'video') {
      showModal.value = !showModal.value;
    }
    principalImage.value = image;
  }

  return {
    showModal,
    principalImage,
    handleClick
  }
}